import api from './api'

const SUB_URL = '/primekg'

export const getAllPrimekgNames = async (type) => {
  try {
      const response = await api.get(`${SUB_URL}/types/${type}`);
      return response.data.names
    } catch (error) {
      console.error('Error fetching node names:', error);
    }
};

export const getAllPrimekgTypes = async () => {
  try {
      const response = await api.get(`${SUB_URL}/types`);
      return response.data.names
    } catch (error) {
      console.error('Error fetching node types:', error);
    }
};

